import {ResourceDrawerActivitiesSection} from '@/shared/components/ui/resource-drawer-sections'
import {useDrugsCategoryContext} from '@/shared/contexts/drugs-category'
import {Tabs} from '@chakra-ui/react'

export function HistoryTab() {
  const {activities} = useDrugsCategoryContext()

  return (
    <Tabs.Content value="history">
      <ResourceDrawerActivitiesSection activities={activities} />
    </Tabs.Content>
  )
}
